// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_oy-0";
export var discountCodeInput = "_oy-1";